
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 22.857 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.38 2.5A2.863 2.863 0 0020.357.477C18.575 0 11.428 0 11.428 0S4.28 0 2.498.478A2.863 2.863 0 00.478 2.5a31.932 31.936 0 000 11.002 2.862 2.862 0 002.02 2.02c1.783.479 8.93.479 8.93.479s7.148 0 8.93-.478A2.862 2.862 0 0022.38 13.5a31.932 31.936 0 000-11.002zM9.142 11.43V4.573l5.938 3.429z"}})])
          )
        }
      }
    